import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DocumentStateResponse } from 'src/app/common/models/DocumentStateResponse';
import { SuccessResponse } from 'src/app/common/models/SuccessRespons';
import { Api, ApigatewayService } from 'src/app/common/services/apigateway.service';
import { environment as env } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class PolicyService {
  constructor(private httpClient: HttpClient, private apigatewayService: ApigatewayService) {}

  // private bestApi = this.apigatewayService.getBestApiGateway();

  // private BASE_URL = `${this.bestApi}${env.ARTICO_API_BASE_URL}/api/v1/artico/policy`;
  private BASE_URL = `${this.apigatewayService.getApiUrl(Api.ARTICO)}/api/v1/artico/policy`;

  // private ARTICO_API_PE_BASE_URL = `${this.bestApi}${env.ARTICO_API_BASE_URL}/api/v1`;
  private ARTICO_API_PE_BASE_URL = `${this.apigatewayService.getApiUrl(Api.ARTICO)}/api/v1`;


  save(data: any) {
    return this.httpClient.post<SuccessResponse>(this.BASE_URL, data);
  }

  getPolicyList(data: any, typeFilter: string, limit: string, dataCode: string) {
    const apiUrl = `${this.BASE_URL}/web/property/br/proposals/list?codEmpresa=BR&offset=0&limit=${limit}&sort=${typeFilter}&filter=${dataCode}`;
    return this.httpClient.get<SuccessResponse>(apiUrl, data);
  }

  generatePrePolicy(proposalNumber: string) {
    const URL = `${this.ARTICO_API_PE_BASE_URL}/web/modular/pe/prepolicy/generate/${proposalNumber}?codEmpresa=PE`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  queryStatusPrePolicy(proposalId: string) {
    const URL = `${this.ARTICO_API_PE_BASE_URL}/web/modular/pe/document/state/prepolicy/${proposalId}?codEmpresa=PE`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  queryStatusFullPolicy(proposalId: string) {
    const URL = `${this.ARTICO_API_PE_BASE_URL}/web/modular/pe/document/state/fullpolicy/${proposalId}?codEmpresa=PE`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  printPrePolicy(proposalNumber: string) {
    const URL = `${this.ARTICO_API_PE_BASE_URL}/web/modular/pe/prepolicy/export/pdf/${proposalNumber}?codEmpresa=PE`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  printPolicy(numberPolicy: string) {
    const URL = `${this.ARTICO_API_PE_BASE_URL}/web/modular/pe/policy/export/pdf/complete/${numberPolicy}?codEmpresa=PE`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  downloadPolicy(numberPolicy: string) {
    const URL = `${this.ARTICO_API_PE_BASE_URL}/web/modular/pe/policy/export/pdf/${numberPolicy}?codEmpresa=PE`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  downloadFullPolicy(numberPolicy: string) {
    const URL = `${this.ARTICO_API_PE_BASE_URL}/web/modular/pe/fullpolicy/export/pdf/${numberPolicy}?codEmpresa=PE`;
    return this.httpClient.get<SuccessResponse>(URL);
  }

  emitPolicy(proposalNumber: string) {
    const URL = `${this.ARTICO_API_PE_BASE_URL}/web/modular/pe/policy/emit?codEmpresa=PE`;
    return this.httpClient.post(URL, { proposalNumber });
  }

  downloadInvoiceQuote(numberPolicy: string, numberQuote: string) {
    const apiUrl = `${this.BASE_URL}/web/policies/invoice-quote/export/pdf/${numberPolicy}/0/quota/${numberQuote}?codEmpresa=BR`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  refreshStatusPayments(policyNumber: string) {
    const apiUrl = `${this.ARTICO_API_PE_BASE_URL}/policies/updateboleto/${policyNumber}?codEmpresa=BR`;
    return this.httpClient.put<any>(apiUrl, '');
  }

  downloadInvoiceQuoteInfo(numberPolicy: string, numberQuote: string) {
    const apiUrl = `${this.ARTICO_API_PE_BASE_URL}/web/policies/invoice-quote/export/pdf/${numberPolicy}/0/quota/${numberQuote}?codEmpresa=BR`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  downloadInvoice(number: string) {
    const apiUrl = `${this.BASE_URL}/web/policies/invoice/export/pdf/${number}/0?codEmpresa=BR`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  getPolicyID(id: string) {
    const apiUrl = `${this.BASE_URL}/web/modular/pe/findPolicy/${id}?codEmpresa=PE`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  getPolicyNumber(policyNumber: string, endorsementNumber: string) {
    const apiUrl = `${this.BASE_URL}/web/property/br/findPolicyByMovement/${policyNumber}/${endorsementNumber}?codEmpresa=BR`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  getEndoConfirm(policyNumber: string, endorsementNumber: string) {
    const apiUrl = `${this.BASE_URL}/web/property/br/endorsement/export/confirm/pdf/${policyNumber}/${endorsementNumber}`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  getEndoProposal(policyNumber: string, endorsementNumber: string) {
    const apiUrl = `${this.BASE_URL}/web/property/br/endorsement/export/proposal/pdf/${policyNumber}/${endorsementNumber}`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  emitEndorsement(data: any) {
    const apiUrl = `${this.ARTICO_API_PE_BASE_URL}/web/modular/pe/endorsement/emit?codEmpresa=PE`;
    return this.httpClient.post<SuccessResponse>(apiUrl, data);
  }

  validateStateEndorsementDocument(policyId: string) {
    const apiUrl = `${this.ARTICO_API_PE_BASE_URL}/web/modular/pe/endorsement/${policyId}/state?codEmpresa=PE`;
    return this.httpClient.get<DocumentStateResponse>(apiUrl);
  }

  exportEndorsementDocument(policyNumber: string, personDocumentNumber: string) {
    const apiUrl = `${this.ARTICO_API_PE_BASE_URL}/web/modular/pe/endorsement/${policyNumber}/${personDocumentNumber}/export?codEmpresa=PE`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  getEndorsements(policyNumber: string) {
    const apiUrl = `${this.ARTICO_API_PE_BASE_URL}/web/modular/pe/endorsement/cession/find/${policyNumber}?codEmpresa=PE`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }

  getPolicyData(id: string) {
    const apiUrl = `${this.ARTICO_API_PE_BASE_URL}/web/modular/pe/policy/find/${id}?codEmpresa=PE`;
    return this.httpClient.get<SuccessResponse>(apiUrl);
  }
}
